<template>
  <header class="site-header" :class="{ scrolled: isScrolled }">
    <div class="container header-inner">
      <router-link to="/" class="brand">
        <span class="brand-mark"><span></span><span></span><span></span></span>
        <span class="brand-copy">
          <strong>ASSFOS</strong>
          <small>SERVICES LTD</small>
        </span>
      </router-link>

      <button class="menu-button" @click="mobileOpen = !mobileOpen" :aria-expanded="mobileOpen">
        <span></span><span></span><span></span>
      </button>

      <nav class="desktop-nav">
        <router-link to="/">Home</router-link>
        <router-link to="/services">Services</router-link>
        <router-link to="/projects">Projects</router-link>
        <router-link to="/about">About</router-link>
        <router-link to="/contact" class="nav-cta">Request a Quote</router-link>
      </nav>

      <div v-if="mobileOpen" class="mobile-nav">
        <router-link @click="mobileOpen = false" to="/">Home</router-link>
        <router-link @click="mobileOpen = false" to="/services">Services</router-link>
        <router-link @click="mobileOpen = false" to="/projects">Projects</router-link>
        <router-link @click="mobileOpen = false" to="/about">About</router-link>
        <router-link @click="mobileOpen = false" to="/contact">Request a Quote</router-link>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader',
  data() {
    return { mobileOpen: false, isScrolled: false }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 20
    }
  }
}
</script>